import { apiClient } from "@/api/client";
import { Team, TeamsRespose } from "@/pages/teams/store/teamsStore";
import { AxiosError } from "axios";
import { create } from "zustand";

interface MediaAgency {
  id: string;
  name: string;
  logo_url: string | null;
  bio: string | null;
  website: string | null;
  industry: string | null;
  size: string | null;
  phone: string | null;
  main_email: string | null;
  gst_id: string | null;
  agency_terms_accepted: boolean | null;
  agency_joined_at: string | null;
}

interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
}

interface MediaAgencyLinks {
  first: string | null;
  last: string | null;
  prev: string | null;
  next: string | null;
}

interface MediaAgencyMeta {
  current_page: number;
  from: number;
  last_page: number;
  links: PaginationLink[];
  path: string;
  per_page: number;
  to: number;
  total: number;
}

interface MediaAgencyResponse {
  data: MediaAgency[];
  links: MediaAgencyLinks;
  meta: MediaAgencyMeta;
}

interface ManageMediaAgencyState {
  agency: MediaAgencyResponse | null;
  fetchAgency: (page: string) => Promise<void>;
}

const useManageMediaAgencyStore = create<ManageMediaAgencyState>((set) => ({
  agency: null,

  fetchAgency: async (page: string) => {
    try {
      const response = await apiClient.get<MediaAgencyResponse>(
        `/media-agency-information?page=${page}`
      );
      set({ agency: response.data });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage =
        axiosError.response?.data?.error || "Failed to fetch people.";
      throw new Error(errorMessage);
    }
  },
}));

export default useManageMediaAgencyStore;
